import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { NotificationService, NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_SUCCESS } from 'ui-components/services/notification-service';

const messages = defineMessages({
  errorTitle: {
    description: 'automationRulesReprocess.errorNotificationTitle',
    defaultMessage: 'Automation Rules Reprocess Error',
    id: 'izGfwj',
  },
  errorContent: {
    description: 'automationRulesReprocess.errorNotificationContent',
    defaultMessage: 'There was an error trying to reprocess automation rules. Please try again.',
    id: 'Z13bpL',
  },
  allDoneTitle: {
    description: 'automationRulesReprocess.allDoneTitle',
    defaultMessage: 'All done!',
    id: 'EReMKl',
  },
  allDoneMessage: {
    description: 'automationRulesReprocess.allDoneMessage',
    defaultMessage: 'Your open orders have been reprocessed!',
    id: 'Ix6gPQ',
  },
});

const pendingBatchIds = new Set();

class AutomationRulesNotificationServiceClass {
  get pusherMessageKey() {
    return 'reprocess';
  }

  registerBatchId(batchId) {
    if (batchId) {
      pendingBatchIds.add(batchId);
    }
  }

  isJobServiceMessageFormat(message) {
    return message?.type === this.pusherMessageKey;
  }

  isV3QueueServiceMessageFormat(message) {
    const batchId = message?.data?.batchId;
    return batchId && pendingBatchIds.has(batchId);
  }

  validateMessage(message) {
    if (!message) {
      return false;
    }

    return this.isJobServiceMessageFormat(message) || this.isV3QueueServiceMessageFormat(message);
  }

  processMessage(message) {
    if (!message) {
      this.showErrorNotification();
      return;
    }

    if (this.isV3QueueServiceMessageFormat(message)) {
      const { batchId, succeeded } = message.data;
      pendingBatchIds.delete(batchId);

      if (succeeded) {
        this.showSuccessNotification();
      } else {
        this.showErrorNotification();
      }
      return;
    }

    this.showSuccessNotification();
  }

  showSuccessNotification() {
    NotificationService.showNotification({
      title: <FormattedMessage {...messages.allDoneTitle} />,
      content: <FormattedMessage {...messages.allDoneMessage} />,
      notificationType: NOTIFICATION_TYPE_SUCCESS,
      dontHide: true,
    });
  }

  showErrorNotification() {
    NotificationService.showNotification({
      title: <FormattedMessage {...messages.errorTitle} />,
      content: <FormattedMessage {...messages.errorContent} />,
      notificationType: NOTIFICATION_TYPE_ERROR,
      dontHide: true,
    });
  }
}

export const AutomationRulesNotificationService = new AutomationRulesNotificationServiceClass();
